import { Link } from "react-router-dom";
import { Paintbrush } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white py-12 px-6 md:px-12" data-testid="footer">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-[#b91c1c] rounded-lg flex items-center justify-center">
                <Paintbrush className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">fasadmalning.se</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              En del av Vi Målar Sverige AB. Professionell fasadmålning 
              för villor och trähus. Kvalitet och trygghet i över 15 år.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4">Tjänster</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>Fasadmålning trähus</li>
              <li>Fasadmålning villa</li>
              <li>Utvändig målning</li>
              <li>Träfasad renovering</li>
            </ul>
          </div>

          {/* Guider */}
          <div>
            <h4 className="font-semibold mb-4">Guider</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <Link to="/guider/fasadmalning-trafasad-komplett-guide" className="hover:text-white transition-colors">
                  Komplett guide fasadmålning
                </Link>
              </li>
              <li>
                <Link to="/guider/vad-kostar-fasadmalning-2026-prisguide" className="hover:text-white transition-colors">
                  Priser fasadmålning 2026
                </Link>
              </li>
              <li>
                <Link to="/guider/akrylatfarg-eller-tacklasyr-vilken-farg-bast" className="hover:text-white transition-colors">
                  Akrylat vs täcklasyr
                </Link>
              </li>
              <li>
                <Link to="/guider" className="hover:text-white transition-colors">
                  Alla guider →
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>Tel: 08-25 46 04</li>
              <li>E-post: info@vimalar.se</li>
              <li>Stockholm med omnejd</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} Vi Målar Sverige AB. Alla rättigheter förbehållna.
          </p>
          <div className="flex gap-6 text-slate-500 text-sm">
            <a href="#" className="hover:text-white transition-colors">Integritetspolicy</a>
            <a href="#" className="hover:text-white transition-colors">Villkor</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
